import React, { Component } from "react";
import NewsItem from "./NewsItem";

export class News extends Component {
  constructor() {
    super();
    this.state = {
      articles: [],
      loading: false,
    };
  }
  async componentDidMount(){
    let url="https://newsapi.org/v2/top-headlines?country=in&apiKey=593ea123154047c3b61f00a60a057039";
    let data= await fetch(url);
    let parseData= await data.json();
    this.setState({articles: parseData.articles})
  }
  render() {
    return (
      <div className="container my-3">
        <h2 style={{textAlign:'center',color:'#e32517'}}>KalTak-Top Headlines</h2>
        <div className="row">
          {this.state.articles.map((element) => {
            return (
              <div className="col md-4" key={element.url}>
                <NewsItem
                  title={element.title?element.title.slice(0,66):""}
                  description={element.description?element.description.slice(0,78):""}
                  imageUrl={element.urlToImage}
                  newsUrl={element.url}
                />
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}

export default News;
